import { Feature } from '@tencent/workbench';
import BaseToolbarFeature from '@framework/workbench/common/feature/base-toolbar-feature';
import { config } from './config';
import { EDIT_TYPE } from '@src/slide/domain/selection/constant/edit-type';


@Feature()
export class ExitMasterEditFeature extends BaseToolbarFeature {
    public id = config.id;
    public currentPageChangeReaction;
    public toolbarService;

    public get curModelIsLayout(): boolean {
        return !!this.getSelectionService().currentSlide?.isLayout;
    }

    public get curModelIsMaster(): boolean {
        return !!this.getSelectionService().currentSlide?.isMaster;
    }

    public exitMasterEdit() {
        this.getAppService().editableServiceLayer?.masterLayoutEditService?.changeEditType(EDIT_TYPE.SLIDE);
    }
}
